import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { useSiteContent } from "../admin/SiteContentContext";

export default function PrivatePay() {
  const { content } = useSiteContent();
  const { privatePaySteps } = content;
  return (
    <main>
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <span className="kicker">Private pay</span>
          <h1 className="hero-heading text-white text-5xl md:text-6xl mt-5">A clear path to dependable support.</h1>
          <p className="text-slate-300 text-lg max-w-3xl mx-auto mt-6 leading-relaxed">
            Private pay gives families flexibility to shape support around their needs, schedule, and priorities. We will walk through the details with you.
          </p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <h3 className="text-slate-400 uppercase tracking-widest text-xs mb-8 text-center">How it works</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {privatePaySteps.map(s => (
              <div key={s.num} className="card-soft p-7 relative">
                <div className="w-10 h-10 rounded-full bg-[#c7e34a] text-[#0b1220] font-bold flex items-center justify-center mb-5">{s.num}</div>
                <p className="text-slate-200 leading-relaxed">{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="card-soft p-10 md:p-14 text-center">
            <h2 className="font-serif-display text-white text-4xl md:text-5xl mb-5">No guesswork.</h2>
            <p className="text-slate-300 leading-relaxed max-w-2xl mx-auto mb-8">We believe a care conversation should feel helpful, not complicated. We can discuss service options, scheduling, and what to expect before you decide anything.</p>
            <Link to="/booking" className="btn-lime"><Calendar className="w-4 h-4" /> Book Consultation <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </section>
    </main>
  );
}
